import { render, staticRenderFns } from "./NoData.vue?vue&type=template&id=a7595512&scoped=true&"
import script from "./NoData.vue?vue&type=script&lang=ts&"
export * from "./NoData.vue?vue&type=script&lang=ts&"
import style0 from "./NoData.vue?vue&type=style&index=0&id=a7595512&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7595512",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VBtn,VImg})
